import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/teachers`;
const token = localStorage.getItem("token");

/// **POST**
// 🔹 Fonction pour ajouter un enseignant
export const createTeacher = async (teacherData) => {
  try {
    const response = await axios.post(`${apiUrl}/add`, teacherData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Erreur lors de l'ajout de l'enseignant :", error);
    throw error;
  }
};

/// **GET**
// 🔹 Fonction pour récupérer les enseignants d'un club
export const getTeachersByClub = async (clubId) => {
  try {
    const response = await axios.get(`${apiUrl}/getByClub/${clubId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Erreur lors de la récupération des enseignants :", error);
    throw error;
  }
};

/// **GET**
// 🔹 Fonction pour récupérer un enseignant par le userId
export const getTeacherByUser = async (userId) => {
  try {
    const response = await axios.get(`${apiUrl}/user/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Erreur lors de la récupération de l'enseignant :", error);
    throw error;
  }
};

/// **POST**
// 🔹 Fonction pour assigner des dojos à un enseignant
export const assignDojosToTeacher = async (teacherId, dojoIds) => {
  try {
    const response = await axios.post(
      `${apiUrl}/assignDojo`,
      { teacherId, dojoIds },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "❌ Erreur lors de l'assignation des dojos à l'enseignant :",
      error
    );
    throw error;
  }
};

/// **POST**
// 🔹 Fonction pour assigner des groupes à un enseignant en prenant en charge plusieurs dojos
export const assignGroupsToTeacher = async (teacherId, assignments) => {
  try {
    const response = await axios.post(
      `${apiUrl}/assignGroups`, // ✅ Correction de l'URL
      { teacherId, assignments }, // ✅ On envoie un objet contenant teacherId + assignments
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "❌ Erreur lors de l'assignation des groupes à l'enseignant :",
      error.response?.data || error.message
    );
    throw error;
  }
};

/// DELETE
export const removeGroupFromTeacher = async (teacherId, groupId) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("❌ Aucun token trouvé !");
      throw new Error("Token manquant !");
    }

    const response = await axios.delete(
      `${apiUrl}/${teacherId}/groups/${groupId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "❌ Erreur lors de la suppression du groupe de l'enseignant :",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Supprimer un Teacher
export const deleteTeacher = async (teacherId) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/deleteTeacher/${teacherId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Erreur lors de la suppression de l'enseignant :", error);
    throw error;
  }
};
